import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Report } from '../../../models/report.model';

@Component({
  selector: 'app-votre-estimation-edit-mode',
  templateUrl: './votre-estimation-edit-mode.component.html',
  styleUrls: ['./votre-estimation-edit-mode.component.scss'],
})
export class VotreEstimationEditModeComponent implements OnChanges {
  @Input() appraisal!: Report.Appraisal;

  @Output() basicInfosChanged = new EventEmitter<Report.Appraisal.BasicInfo>();
  @Output() redirectToReferences = new EventEmitter();

  votreEstimationForm = new FormGroup({
    lead: new FormControl(''),
    comment: new FormControl(''),
    chosenValue: new FormControl(''),
    chosenHighValue: new FormControl(''),
    chosenLowValue: new FormControl(''),
    conclusion: new FormControl(''),
  });

  private newBasicInfos!: Report.Appraisal.BasicInfo;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appraisal'].currentValue) {
      const currentAppraisal = changes['appraisal'].currentValue;
      if (currentAppraisal) {
        this.newBasicInfos = currentAppraisal.basicInfo;
        this.setFormValues();
      }
    }
  }

  leadChanged(event: Event) {
    this.newBasicInfos = {
      ...this.newBasicInfos,
      lead: (event.target as HTMLInputElement).value,
    };

    this.basicInfosChanged.emit(this.newBasicInfos);
  }

  commentChanged(event: Event) {
    this.newBasicInfos = {
      ...this.newBasicInfos,
      comment: (event.target as HTMLInputElement).value,
    };

    this.basicInfosChanged.emit(this.newBasicInfos);
  }

  chosenValueChanged(event: Event) {
    this.newBasicInfos = {
      ...this.newBasicInfos,
      chosenValue: (event.target as HTMLInputElement).value,
    };

    this.basicInfosChanged.emit(this.newBasicInfos);
  }

  chosenHighValueChanged(event: Event) {
    this.newBasicInfos = {
      ...this.newBasicInfos,
      chosenHighValue: (event.target as HTMLInputElement).value,
    };

    this.basicInfosChanged.emit(this.newBasicInfos);
  }

  chosenLowValueChanged(event: Event) {
    this.newBasicInfos = {
      ...this.newBasicInfos,
      chosenLowValue: (event.target as HTMLInputElement).value,
    };

    this.basicInfosChanged.emit(this.newBasicInfos);
  }

  conclusionChanged(event: Event) {
    this.newBasicInfos = {
      ...this.newBasicInfos,
      conclusion: (event.target as HTMLInputElement).value,
    };

    this.basicInfosChanged.emit(this.newBasicInfos);
  }

  private setFormValues(): void {
    this.votreEstimationForm.controls.lead.setValue(
      this.appraisal.basicInfo.lead,
    );

    this.votreEstimationForm.controls.comment.setValue(
      this.appraisal.basicInfo.comment,
    );

    this.votreEstimationForm.controls.chosenValue.setValue(
      this.appraisal.basicInfo.chosenValue,
    );

    this.votreEstimationForm.controls.chosenHighValue.setValue(
      this.appraisal.basicInfo.chosenHighValue,
    );

    this.votreEstimationForm.controls.chosenLowValue.setValue(
      this.appraisal.basicInfo.chosenLowValue,
    );

    this.votreEstimationForm.controls.conclusion.setValue(
      this.appraisal.basicInfo.conclusion,
    );
  }

  redirectToReferencesOnClick() {
    this.redirectToReferences.emit();
  }
}
